import type { DarijaEntry } from '../domain/darija'

export function speakDarijaEntry(
  entry: DarijaEntry,
): void {
  if (!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) return

  const utterance = new SpeechSynthesisUtterance(entry.expression)
  utterance.lang = entry.audioLocale
  const voices = window.speechSynthesis.getVoices()
  utterance.voice = voices.find((voice) => voice.lang.toLowerCase() === 'ar-ma')
    ?? voices.find((voice) => voice.lang.toLowerCase().startsWith('ar')) ?? null
  window.speechSynthesis.cancel()
  window.speechSynthesis.speak(utterance)
}
